import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Container, Form, Grid, Header, Segment } from 'semantic-ui-react';
import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import '../css/LTIPlayerLauncher.less';

import { VIEW_SELECTION } from '../managers/NavigationManager';

import { setSessionStorageItem } from '../utils/session';

import Auth from '../managers/AuthManager';

/**
 * AgentLinkHandlerView
 *
 * Route handler at /agentlink. Receives a customer-service deep link with
 * `?agentId=...`, stashes the agentId in sessionStorage under `c2c_agentId`,
 * and redirects to / (or /signin if not yet authenticated).
 *
 * After auth, FloatingHelpLauncher reads the agentId and opens the TESS
 * microsite iframe modal, passing agentId via postMessage.
 */
export default
@inject('navigationManager')
@observer
class AgentLinkHandlerView extends Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: null, errorTitle: null };
    this.Logo = SatCoreComponent('Logo');
  }

  async componentDidMount() {
    const { history, location, navigationManager } = this.props;
    navigationManager.setView(VIEW_SELECTION.LOGIN);

    const urlParams = new URLSearchParams(location.search);
    let agentId = null;
    let error = '';

    if (urlParams.has('error') && urlParams.get('error') !== 'null') {
      error = urlParams.get('error');
    }

    if (urlParams.has('agentId') && urlParams.get('agentId') !== 'null') {
      agentId = urlParams.get('agentId');
    }

    if (error) {
      this.verificationError('Error', error);
    } else if (agentId) {
      try {
        setSessionStorageItem('c2c_agentId', agentId);
        console.info('[AgentLink] Saved c2c_agentId to sessionStorage', { agentId });
      } catch (storageError) {
        console.error(storageError);
        this.verificationError('Error', 'Not Authorized');
        return;
      }
      if (Auth.loggedIn()) {
        history.replace('/');
      } else {
        history.replace('/signin');
      }
    } else {
      this.verificationError('Error', 'Not Authorized');
    }
  }

  failPanel = () => {
    const { errorTitle, errorMessage } = this.state;
    const { Logo } = this;
    return (
      <Grid className='fullHeight' textAlign='center' verticalAlign='middle'>
        <Grid.Column className='max-width-558'>
          <Form>
            <Header as='h2' attached='top' block>
              <div className='message-header'>
                <Logo />
                <div>{errorTitle}</div>
              </div>
            </Header>
            <Segment attached>
              <Form.Field>
                <Container className='login-error-message' text>
                  {errorMessage}
                </Container>
              </Form.Field>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }

  verificationError = (errorTitle, errorMessage) => {
    this.setState({ errorMessage, errorTitle });
  }

  render() {
    const { errorMessage } = this.state;
    if (errorMessage) {
      return (
        <div className='lrn-player-launcher-container student-assignment-launcher-container'>
          {this.failPanel()}
        </div>
      );
    }
    return null;
  }
}

SatCoreRegister('AgentLinkHandlerView', AgentLinkHandlerView);
